module.exports = __webpack_public_path__ + "static/media/item_7_3_comp.bf8465de.png";